/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
import Routes from 'routes';
import NavigationScroll from 'layout/NavigationScroll';
import Snackbar from 'ui-component/extended/Snackbar';
import ThemeCustomization from 'themes';
import { ToastContainer } from 'react-toastify';
import '@fontsource/gemunu-libre/700.css';
import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';

// Optional toast notification styles
// import 'react-toastify/dist/ReactToastify.css';

const App = () => {
    return (
        <ThemeCustomization>
            <NavigationScroll>
                <AuthProvider>
                    <Routes />
                    <Snackbar />

                    <ToastContainer position="top-right" autoClose={2000} />
                </AuthProvider>
            </NavigationScroll>
        </ThemeCustomization>
    );
};

export default App;

// import Routes from 'routes';
// import NavigationScroll from 'layout/NavigationScroll';
// import Snackbar from 'ui-component/extended/Snackbar';
// import ThemeCustomization from 'themes';
// // import 'react-toastify/dist/ReactToastify.css';
// // import 'react-toastify/dist/ReactToastify.css';
// import '@fontsource/gemunu-libre/700.css';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';

// // ==============================|| APP ||============================== //

// const App = () => {
//     return (
//         <ThemeCustomization>
//             <NavigationScroll>
//                 <AuthProvider>
//                     <>
//                         <Routes />
//                         <Snackbar />
//                     </>
//                 </AuthProvider>
//             </NavigationScroll>
//         </ThemeCustomization>
//     );
// };

// export default App;
